import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useSelector } from "react-redux";
import { selectors } from "../../redux-store";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chartPaper: {
      width: "100%",
      height: 400,
      marginBottom: "10px",
    },
  }),
);

const useDevicesPerDayLinearChart = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const devicesPerDayStats = useSelector(selectors.getDevicesPerDayList);

  const data = useMemo(() => {
    let data;
    if (devicesPerDayStats) {
      data = [
        {
          id: 1,
          data: devicesPerDayStats.map((stat) => {
            return { x: stat.day, y: stat.count };
          }),
        },
      ];
    }
    return data;
  }, [devicesPerDayStats]);

  // console.log(data[0].data);

  return {
    styles,
    classes,
    atomicStyles,
    data,
  };
};

export { useDevicesPerDayLinearChart as default };
